import { useState, useCallback } from 'react';
import { WALLET } from '@blink/components/src/types';

export const useWalletSelection = () => {
    const [selectedWallet, setSelectedWallet] = useState<WALLET | null>(null);

    const handleMetamaskSelect = useCallback(() => {
        setSelectedWallet(WALLET.META_MASK);
    }, []);

    const handleRabbySelect = useCallback(() => {
        setSelectedWallet(WALLET.RABBY);
    }, []);

    const handleWalletConnectSelect = useCallback(() => {
        setSelectedWallet(WALLET.WALLET_CONNECT);
    }, []);

    return {
        selectedWallet,
        handleMetamaskSelect,
        handleRabbySelect,
        handleWalletConnectSelect,
    };
};
